"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var react_router_1 = require("react-router");
var colors_1 = require("@material-ui/core/colors");
var sleepService_1 = require("../../../app/services/sleepService");
var translate_1 = __importDefault(require("../../../app/localization/translate"));
var components_1 = require("../../../common/components");
var breadcrumbUtil_1 = require("../../../common/breadcrumbUtil");
var dateUtils_1 = require("../../../youwell-common/dateUtils");
var urls_1 = __importDefault(require("../../../app/urls"));
var useAutosaveForm_1 = __importDefault(require("../../../youwell-common/useAutosaveForm"));
var constants_1 = require("./constants");
var icons_1 = require("../../../common/icons");
var validationUtils_1 = require("../../../youwell-common/validationUtils");
var utils_1 = require("./utils");
var store_1 = require("../../../app/store");
var image_1 = require("../../../common/image");
var LogWakeups_1 = __importDefault(require("./components/LogWakeups"));
var LogNaps_1 = __importDefault(require("./components/LogNaps"));
var DayView_1 = __importDefault(require("./components/DayView"));
var styles = function (theme) {
    var _a, _b, _c, _d, _e;
    return (0, core_1.createStyles)({
        top: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(2),
        },
        futureWarning: {
            border: theme.youwell.borders.dim,
            background: theme.palette.grey[100],
            padding: theme.spacing(4, 2),
            margin: theme.spacing(4, 0),
        },
        content: {
            marginTop: theme.spacing(4),
            '&$disabled': {
                opacity: 0.6,
            },
        },
        disabled: {},
        box: (_a = {
                marginBottom: theme.spacing(4),
                boxShadow: theme.shadows[2],
                backgroundColor: colors_1.grey[100],
                borderRadius: theme.youwell.shapes.borderRadius
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2),
            },
            _a),
        entry: {
            '&+&': {
                marginTop: theme.spacing(6),
            },
        },
        inline: {
            display: 'flex',
            flexDirection: 'column',
        },
        entryLabelFlexWrapper: (_b = {
                marginBottom: theme.spacing(1),
                display: 'flex'
            },
            _b[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
            },
            _b),
        textAndIconWrapper: {
            display: 'flex',
        },
        entryLabel: {
            marginRight: theme.spacing(2),
        },
        entryTitle: {},
        timeInput: {
            width: '100%',
            border: theme.youwell.borders.dim,
            padding: theme.spacing(1),
        },
        emptyInput: {
            backgroundColor: theme.palette.common.white,
        },
        filledInInput: {
            background: theme.youwell.colors.inputBackground,
        },
        errorInput: {
            border: theme.youwell.borders.error,
        },
        textInput: {
            border: theme.youwell.borders.dim,
            padding: theme.spacing(1, 3),
        },
        slider: {
            marginTop: theme.spacing(2),
        },
        entryDescription: {
            marginBottom: theme.spacing(1),
        },
        bottom: (_c = {
                margin: theme.spacing(6, 0, 12),
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
            },
            _c[theme.breakpoints.down('xs')] = {
                justifyContent: 'center',
            },
            _c),
        bottomValidation: {
            marginRight: theme.spacing(2),
        },
        doneBtn: {
            padding: theme.spacing(1, 10),
            margin: theme.spacing(2, 0, 2, 1),
        },
        alwaysPresentContent: {
            backgroundColor: theme.palette.background.default,
            padding: theme.spacing(4),
            borderRadius: theme.youwell.shapes.borderRadius,
        },
        ratingSliderIconSection: {
            display: 'flex',
            justifyContent: 'space-between',
            margin: theme.spacing(0, 2),
        },
        remindUserToAnswerText: (_d = {
                color: theme.palette.error.main,
                marginLeft: theme.spacing(1)
            },
            _d[theme.breakpoints.down('xs')] = {
                marginLeft: 0,
            },
            _d),
        remindUserToAnswerTextNextLine: {
            color: theme.palette.error.main,
        },
        skipAnsweringText: (_e = {
                color: theme.palette.error.main,
                textDecoration: 'underline',
                marginLeft: theme.spacing(1),
                '&:hover': {
                    cursor: 'pointer',
                }
            },
            _e[theme.breakpoints.down('xs')] = {
                marginLeft: 0,
            },
            _e),
        requiredMessage: {
            marginTop: theme.spacing(1),
        },
    });
};
var useStyles = (0, core_1.makeStyles)(function (theme) { return styles(theme); }, { name: 'LogDay' });
var validators = {
    bedTime: validationUtils_1.validateRequired,
    sleepAtemptTime: validationUtils_1.validateRequired,
    sleepTime: validationUtils_1.validateRequired,
    wakeTime: validationUtils_1.validateRequired,
    outOfBedTime: validationUtils_1.validateRequired,
};
var LogDay = function () {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h;
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var translate = (0, translate_1.default)();
    var theme = (0, core_1.useTheme)();
    var dateString = (0, react_router_1.useParams)().date;
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var sleepEntries = (0, store_1.useYouwellSelector)(function (state) { return state.sleepDataStore.entries; });
    var date = React.useMemo(function () { return (0, dateUtils_1.getLocalDate)(dateString); }, [dateString]);
    var currentValues = React.useMemo(function () { return sleepEntries === null || sleepEntries === void 0 ? void 0 : sleepEntries.find(function (d) { return (0, dateUtils_1.isSameDate)(d.date, date); }); }, [date, sleepEntries]);
    var _j = React.useState(false), showDayView = _j[0], setShowDayView = _j[1];
    var _k = React.useState(false), shouldValidate = _k[0], setShouldValidate = _k[1];
    var _l = React.useState({ hasErrors: false }), validationErrors = _l[0], setValidationErrors = _l[1];
    // reset internal state on date change
    React.useEffect(function () {
        setValidationErrors({ hasErrors: false });
        setShowDayView(false);
        setShouldValidate(false);
    }, [dateString]);
    var saveData = React.useCallback(function (updatedValues, callback, background) {
        var _a, _b, _c, _d, _e;
        var lastNightWakeupHasNoWakeTime = (_c = (_a = updatedValues.nightWakeups) === null || _a === void 0 ? void 0 : _a[((_b = updatedValues.nightWakeups) === null || _b === void 0 ? void 0 : _b.length) - 1]) === null || _c === void 0 ? void 0 : _c.wakeTime;
        var nightWakeupsWithWaketime = (_d = updatedValues.nightWakeups) === null || _d === void 0 ? void 0 : _d.filter(function (d) { return d.wakeTime; });
        var allNightWakeupsHaveWakeTime = (nightWakeupsWithWaketime === null || nightWakeupsWithWaketime === void 0 ? void 0 : nightWakeupsWithWaketime.length) === ((_e = updatedValues.nightWakeups) === null || _e === void 0 ? void 0 : _e.length);
        if (allNightWakeupsHaveWakeTime || lastNightWakeupHasNoWakeTime) {
            var sleepData = {
                entry: __assign(__assign({}, updatedValues), { date: date, nightWakeups: lastNightWakeupHasNoWakeTime ? nightWakeupsWithWaketime : updatedValues.nightWakeups }),
            };
            (0, sleepService_1.updateSleepEntry)(dispatch, sleepData, { background: background, callback: callback });
        }
    }, [date, dispatch]);
    var _m = (0, useAutosaveForm_1.default)(saveData, { date: date }, currentValues), values = _m.values, handleSliderChange = _m.handleSliderChange, handleValueChange = _m.handleValueChange, ensureSaved = _m.ensureSaved;
    React.useEffect(function () {
        if (shouldValidate) {
            var allValidationErrors = (0, validationUtils_1.validateAllFields)(values, validators);
            setValidationErrors(allValidationErrors);
        }
    }, [shouldValidate, values]);
    var handleSubPropertyChange = function (name) { return function (event) {
        var _a;
        var updated = __assign(__assign({}, values.sleepProperties), (_a = {}, _a[name] = event.target.value, _a));
        handleValueChange('sleepProperties')(updated);
    }; };
    var handleTimeChange = function (name) { return function (value) {
        var timeWithCorrectDate = (0, utils_1.getTimeWithCorrectDate)(value, date, utils_1.SleepLoggingType.dayLogging);
        handleValueChange(name)(timeWithCorrectDate);
    }; };
    var handleChange = function (name) { return function (value) {
        handleTimeChange(name)(value);
    }; };
    var clickDone = function () {
        var allValidationErrors = (0, validationUtils_1.validateAllFields)(values, validators);
        if (!(0, validationUtils_1.checkHasErrors)(allValidationErrors)) {
            ensureSaved(function () {
                setShowDayView(true);
            });
        }
        else {
            setShouldValidate(true);
            setValidationErrors(allValidationErrors);
        }
    };
    var dateIsFuture = (0, dateUtils_1.isFuture)(date);
    return (React.createElement(components_1.PageLayout, { title: translate('sleepDiary.header'), breadcrumb: (0, breadcrumbUtil_1.getBreadCrumb)(translate('sleepDiary.logNight'), translate, clientConfig, undefined, [{ text: translate('sleepDiary.header'), url: urls_1.default.inside.pages.sleepDiary }]) },
        React.createElement("div", { className: classes.top },
            React.createElement(core_1.Typography, { variant: "h6" }, translate('sleepDiary.registrationForDescription', { dateStart: (0, dateUtils_1.longDate)((0, dateUtils_1.addDays)(date, -1), translate), dateEnd: (0, dateUtils_1.longDate)(date, translate) }))),
        dateIsFuture && (React.createElement(core_1.Typography, { className: classes.futureWarning, color: "primary" }, translate('sleepDiary.cannotRegisterInFuture'))),
        React.createElement("div", { className: (0, classnames_1.default)(classes.content, (_a = {}, _a[classes.disabled] = dateIsFuture, _a)) },
            React.createElement("div", { className: classes.box },
                React.createElement("div", { className: classes.alwaysPresentContent },
                    React.createElement("div", { className: classes.entry },
                        React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.activityRatingTitle')),
                        React.createElement(core_1.Typography, { variant: "body2", className: classes.entryDescription }, translate('sleepDiary.activityRatingDescription')),
                        React.createElement(components_1.YouwellSlider, { disabled: dateIsFuture, className: classes.slider, value: values.daytimeActivityRating, onChange: handleSliderChange('daytimeActivityRating'), min: 1, max: 5, marks: constants_1.daytimeActivityRatings.map(function (d) { return ({ value: d.id, label: translate(d.label) }); }) }),
                        React.createElement("div", { className: classes.ratingSliderIconSection },
                            React.createElement(image_1.WorkingWithLaptopIcon, { color: theme.palette.primary.main }),
                            React.createElement(image_1.WalkingWithDogIcon, { color: theme.palette.primary.main }),
                            React.createElement(image_1.PlayingSoccerIcon, { color: theme.palette.primary.main }))),
                    React.createElement("div", { className: classes.entry },
                        React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.drugsOrAlcoholUse')),
                        React.createElement(core_1.Typography, { variant: "body2", className: classes.entryDescription }, translate('sleepDiary.drugsOrAlcoholUseDescription')),
                        React.createElement("div", null,
                            React.createElement(core_1.Input, { id: "sleepMedication", className: (0, classnames_1.default)(classes.textInput, ((_g = values.sleepProperties) === null || _g === void 0 ? void 0 : _g.sleepMedication) ? classes.filledInInput : classes.emptyInput), value: ((_h = values.sleepProperties) === null || _h === void 0 ? void 0 : _h.sleepMedication) || '', placeholder: translate('sleepDiary.drugsOrAlcoholInputPlaceHolder'), onChange: handleSubPropertyChange('sleepMedication'), fullWidth: true, disabled: dateIsFuture, disableUnderline: true, required: true })))),
                React.createElement(LogNaps_1.default, { values: values, date: date, disabled: dateIsFuture, handleValueChange: handleValueChange })),
            React.createElement("div", { className: classes.box },
                React.createElement("div", { className: classes.alwaysPresentContent },
                    React.createElement("div", { className: classes.entry },
                        React.createElement("div", { className: classes.inline },
                            React.createElement("div", { className: classes.entryLabelFlexWrapper },
                                React.createElement("div", { className: classes.textAndIconWrapper },
                                    React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryLabel }, translate('sleepDiary.whenDidYouGoToSleep')),
                                    React.createElement(icons_1.SleepIcon, null))),
                            React.createElement(components_1.TimePicker, { className: (0, classnames_1.default)(classes.timeInput, values.bedTime ? classes.filledInInput : classes.emptyInput, (_b = {}, _b[classes.errorInput] = !!validationErrors.bedTime, _b)), value: values.bedTime, onChange: handleChange('bedTime'), validation: (0, utils_1.validateTimeBeforeThan)(values.sleepAtemptTime, date, utils_1.SleepLoggingType.nightLogging), validationMessage: "".concat(translate('sleepDiary.inCorrectSleepDataInputOrder')), disabled: dateIsFuture, defaultValue: constants_1.defaultSleepTime, disableUnderline: true, inputAdornmentBeforeInput: true }),
                            !!validationErrors.bedTime && (React.createElement(core_1.Typography, { variant: "caption", color: "error", className: classes.requiredMessage }, translate('sleepDiary.rememberToFillOut'))))),
                    React.createElement("div", { className: classes.entry },
                        React.createElement("div", { className: classes.inline },
                            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryLabel }, translate('sleepDiary.whenDidYouTryToSleep')),
                            React.createElement(components_1.TimePicker, { className: (0, classnames_1.default)(classes.timeInput, values.sleepAtemptTime ? classes.filledInInput : classes.emptyInput, (_c = {}, _c[classes.errorInput] = !!validationErrors.sleepAtemptTime, _c)), value: values.sleepAtemptTime, onChange: handleChange('sleepAtemptTime'), validation: (0, utils_1.validateTimeLaterThan)(values.bedTime, date, utils_1.SleepLoggingType.nightLogging), validationMessage: "".concat(translate('sleepDiary.inCorrectSleepDataInputOrder')), disabled: dateIsFuture, defaultValue: constants_1.defaultSleepTime, disableUnderline: true, inputAdornmentBeforeInput: true }),
                            !!validationErrors.sleepAtemptTime && (React.createElement(core_1.Typography, { variant: "caption", color: "error", className: classes.requiredMessage }, translate('sleepDiary.rememberToFillOut'))))),
                    React.createElement("div", { className: classes.entry },
                        React.createElement("div", { className: classes.inline },
                            React.createElement("div", { className: classes.entryLabelFlexWrapper },
                                React.createElement("div", { className: classes.textAndIconWrapper },
                                    React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryLabel }, translate('sleepDiary.whenDidYouSleep')),
                                    React.createElement(image_1.SleepSmileyIcon, null))),
                            React.createElement(components_1.TimePicker, { className: (0, classnames_1.default)(classes.timeInput, values.sleepTime ? classes.filledInInput : classes.emptyInput, (_d = {}, _d[classes.errorInput] = !!validationErrors.sleepTime, _d)), value: values.sleepTime, onChange: handleChange('sleepTime'), validation: (0, utils_1.validateTimeLaterThan)(values.sleepAtemptTime, date, utils_1.SleepLoggingType.nightLogging), validationMessage: "".concat(translate('sleepDiary.inCorrectSleepDataInputOrder')), disabled: dateIsFuture, defaultValue: constants_1.defaultSleepTime, disableUnderline: true, inputAdornmentBeforeInput: true }),
                            !!validationErrors.sleepTime && (React.createElement(core_1.Typography, { variant: "caption", color: "error", className: classes.requiredMessage }, translate('sleepDiary.rememberToFillOut'))))))),
            React.createElement(LogWakeups_1.default, { values: values, handleValueChange: handleValueChange, disabled: dateIsFuture }),
            React.createElement("div", { className: classes.box },
                React.createElement("div", { className: classes.alwaysPresentContent },
                    React.createElement("div", { className: classes.entry },
                        React.createElement("div", { className: classes.inline },
                            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryLabel }, translate('sleepDiary.whenDidYouWakeUp')),
                            React.createElement(components_1.TimePicker, { className: (0, classnames_1.default)(classes.timeInput, values.wakeTime ? classes.filledInInput : classes.emptyInput, (_e = {}, _e[classes.errorInput] = !!validationErrors.wakeTime, _e)), value: values.wakeTime, onChange: handleTimeChange('wakeTime'), validation: (0, utils_1.validateTimeBeforeThan)(values.outOfBedTime, date, utils_1.SleepLoggingType.dayLogging), validationMessage: "".concat(translate('sleepDiary.inCorrectSleepDataInputOrder')), disabled: dateIsFuture, defaultValue: constants_1.defaultWakeTime, disableUnderline: true, inputAdornmentBeforeInput: true }),
                            !!validationErrors.wakeTime && (React.createElement(core_1.Typography, { variant: "caption", color: "error", className: classes.requiredMessage }, translate('sleepDiary.rememberToFillOut'))))),
                    React.createElement("div", { className: classes.entry },
                        React.createElement("div", { className: classes.inline },
                            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryLabel }, translate('sleepDiary.whenDidYouGetOutOfBed')),
                            React.createElement(components_1.TimePicker, { className: (0, classnames_1.default)(classes.timeInput, values.outOfBedTime ? classes.filledInInput : classes.emptyInput, (_f = {}, _f[classes.errorInput] = !!validationErrors.outOfBedTime, _f)), value: values.outOfBedTime, onChange: handleTimeChange('outOfBedTime'), validation: (0, utils_1.validateTimeLaterThan)(values.wakeTime, date, utils_1.SleepLoggingType.dayLogging), validationMessage: "".concat(translate('sleepDiary.inCorrectSleepDataInputOrder')), disabled: dateIsFuture, defaultValue: constants_1.defaultWakeTime, disableUnderline: true, inputAdornmentBeforeInput: true }),
                            !!validationErrors.outOfBedTime && (React.createElement(core_1.Typography, { variant: "caption", color: "error", className: classes.requiredMessage }, translate('sleepDiary.rememberToFillOut'))))),
                    React.createElement("div", { className: classes.entry },
                        React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.sleepRating')),
                        React.createElement(components_1.YouwellSlider, { className: classes.slider, value: values.sleepRating, onChange: handleSliderChange('sleepRating'), min: 1, max: 5, marks: constants_1.sleepRatings.map(function (d) { return ({ value: d.id, label: translate(d.label) }); }), disabled: dateIsFuture }),
                        React.createElement("div", { className: classes.ratingSliderIconSection },
                            React.createElement(image_1.BadFaceIcon, { color: theme.palette.primary.main }),
                            React.createElement(image_1.OkFaceIcon, { color: theme.palette.primary.main }),
                            React.createElement(image_1.HappyFaceIcon, { color: theme.palette.primary.main })))))),
        React.createElement("div", { className: classes.bottom },
            validationErrors.hasErrors && (React.createElement(core_1.Typography, { variant: "subtitle2", color: "error", className: classes.bottomValidation }, translate('sleepDiary.pleaseFillOutAllFields'))),
            React.createElement(core_1.Button, { className: classes.doneBtn, variant: "contained", color: "secondary", onClick: clickDone, disabled: dateIsFuture }, translate('sleepDiary.done'))),
        React.createElement(DayView_1.default, { date: date, open: showDayView, onClose: function () { return setShowDayView(false); } })));
};
exports.default = LogDay;
